import { useEffect } from 'react';
import { FieldValues, FormState } from 'react-hook-form';
import { useBlocker } from 'react-router-dom';

const useConfirmation = <T extends FieldValues>(formState: FormState<T>) => {
  const hasDirtyFields = !!Object.keys(formState.dirtyFields).length;
  useEffect(() => {
    const beforeUnload = (e: BeforeUnloadEvent) => {
      if (hasDirtyFields) {
        e.preventDefault();
      }
    };

    window.addEventListener('beforeunload', beforeUnload);

    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [hasDirtyFields]);
  const blocker = useBlocker(hasDirtyFields);

  return { isBlocked: blocker.state === 'blocked', proceed: blocker.proceed, reset: blocker.reset };
};

export default useConfirmation;
